module.exports = __webpack_public_path__ + "static/media/d3.8ce61acb.png";